import { Button, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';

import type { VenueData, VenueDetailData } from './types';

export const getVenueTableColumns = (args: {
  onView: (record: VenueData) => void;
  onEdit: (record: VenueData) => void;
  onDelete: (record: VenueData) => void;
}) => {
  const { onView, onEdit, onDelete } = args;

  const columns: ColumnsType<VenueData> = [
    {
      title: '活動空間名稱',
      dataIndex: 'name',
    },
    {
      title: '地址',
      dataIndex: 'address',
    },
    {
      title: '容納人數',
      dataIndex: 'capacity',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 300,
      render: (_, record) => {
        return (
          <Space>
            <Button type="primary" onClick={() => onView(record)}>
              查看
            </Button>
            <Button onClick={() => onEdit(record)}>編輯</Button>
            <Button type="primary" danger onClick={() => onDelete(record)}>
              刪除
            </Button>
          </Space>
        );
      },
    },
  ];

  return columns;
};

export const getOpeningHours = (
  operatingHoursInfo: Omit<VenueDetailData['operatingHours'][0], 'day'>
) => {
  const { isDisabled, isAllDayOpen, times } = operatingHoursInfo;

  if (isDisabled) {
    return '非開放';
  }
  if (isAllDayOpen) {
    return '24小時開放';
  }
  if (times.length === 0) {
    return '尚未設定時間';
  }
  return times;
};
